import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../utils/api"; // Import the login function
import { decrypt, encrypt } from "../utils/cryptoUtils"; // Import encryption utilities
import { loginSuccess } from "../redux/LoginSlice";
import Logo from "../assets/FullLogo.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    emailError: "",
    passwordError: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const login_Otp = useSelector((state) => state.login?.loginData);
  const registerOtp = useSelector((state) => state.login?.RegisterOtp);
  const email = registerOtp?.userdatils?.email || login_Otp?.userdatils?.email || "";
  const mid = String(registerOtp?.userdatils?.mid || login_Otp?.userdatils?.user_id || "");  

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      emailError: "",
      passwordError: "",
    };

    // Email validation

    if (!formData.email || formData.email.trim() === ""){
      newErrors.emailError = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.emailError = "Please enter a valid email address.";
      isValid = false;
    }

    // Password validation
    if (!formData.password){
      newErrors.passwordError = "Password is required.";
      isValid = false;
    }
    else if (formData.password.length < 6) {
      newErrors.passwordError = "Password must be at least 6 characters.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validate form and stop if validation fails
    if (!validateForm()) {
      return;
    }
  
    try {
      // Convert email and password to a JSON string
      const jsonData = JSON.stringify({
        email: formData.email,
        password: formData.password,
      });
  
      // Encrypt the JSON string
      const encrypted = encrypt(jsonData);
  
      // Log the encrypted and decrypted data for debugging
      console.log("Encrypted Data:", encrypted);
      console.log("Decrypted Data:", decrypt(encrypted));
  
      // Call the login API
      const response = await login(encrypted);
  
      if (response?.userdatils?.email_verified === 1 || response?.userdatils?.email_verified === 0) {
        dispatch(loginSuccess(response));
        toast.success(response.msg);
      
        if (response.userdatils.email_verified === 1) {
          navigate("/dashboard");
        } else {
          navigate("/otp");
        }
      } else {
        setError(response.token || "Unknown error");
      }      
    } catch (err) {
      // Log the error for debugging
      console.error("Login Error:", err.message);
  
      // Display the error message to the user
      setError(err.message);
    }
  };

  const handleSignUpClick = () => {
    navigate("/register"); // Navigate to the Register page
  };

  const handleForgotPassword = () => {
    navigate("/forgot/password/email"); // Navigate to the Register page
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      {/* Left Side - Form */}
      <div className="w-full h-screen md:w-1/2 flex flex-col justify-center items-center bg-white px-6 md:px-12 py-8">
        <div className="mb-8 md:mb-8">
          <img src={Logo} alt="Company Logo" className="h-64 md:h-64" />
        </div>
        <div className="w-full max-w-md">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 ">Sign In</h2>
          <p className="text-gray-500 mb-6 mt-3">Enter your email and password to sign in!</p>
          <form onSubmit={handleSubmit}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email<span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter your Email"
              // className="h-10 w-full rounded-lg border border-gray-300 py-2.5 pl-4 text-sm text-gray-800 shadow-sm placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring focus:ring-[#2663EB] mt-2"
              className={`w-full px-4 py-2 rounded-md border ${
                errors.emailError ? 'border-red-500' : 'border-gray-300'
              } focus:outline-none focus:ring-2 placeholder:text-sm text-sm ${
                errors.emailError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
              }`}
              value={formData.email}
              onChange={handleChange}
            />
            {errors.emailError && <p className="text-red-500 text-sm mt-1">{errors.emailError}</p>}



            <label className="block text-sm font-medium text-gray-700 mt-4 mb-1">
              Password<span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Enter your password"
                // className="h-10 w-full rounded-lg border border-gray-300 py-2.5 pl-4 pr-11 text-sm text-gray-800 shadow-sm placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring focus:ring-[#2663EB] mt-2"
                className={`w-full px-4 py-2 rounded-md border ${
                  errors.passwordError ? 'border-red-500' : 'border-gray-300'
                } focus:outline-none focus:ring-2 placeholder:text-sm pr-10 text-sm ${
                  errors.passwordError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                }`}
                value={formData.password}
                onChange={handleChange}
              />
              {/* Eye icon with toggle functionality */}
              <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      // 👁️‍🗨️ Eye Open SVG

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="18px"
                        viewBox="0 -960 960 960"
                        width="18px"
                        fill="#434343"
                      >
                        <path d="M480-312q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm0-72q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 192q-142.6 0-259.8-78.5Q103-349 48-480q55-131 172.2-209.5Q337.4-768 480-768q142.6 0 259.8 78.5Q857-611 912-480q-55 131-172.2 209.5Q622.6-192 480-192Zm0-288Zm0 216q112 0 207-58t146-158q-51-100-146-158t-207-58q-112 0-207 58T127-480q51 100 146 158t207 58Z" />
                      </svg>

                      
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#434343"><path d="m637-425-62-62q4-38-23-65.5T487-576l-62-62q13-5 27-7.5t28-2.5q70 0 119 49t49 119q0 14-2.5 28t-8.5 27Zm133 133-52-52q36-28 65.5-61.5T833-480q-49-101-144.5-158.5T480-696q-26 0-51 3t-49 10l-58-58q38-15 77.5-21t80.5-6q143 0 261.5 77.5T912-480q-22 57-58.5 103.5T770-292Zm-2 202L638-220q-38 14-77.5 21t-80.5 7q-143 0-261.5-77.5T48-480q22-57 58-104t84-85L90-769l51-51 678 679-51 51ZM241-617q-35 28-65 61.5T127-480q49 101 144.5 158.5T480-264q26 0 51-3.5t50-9.5l-45-45q-14 5-28 7.5t-28 2.5q-70 0-119-49t-49-119q0-14 3.5-28t6.5-28l-81-81Zm287 89Zm-96 96Z"/></svg>
                      // 🙈 Eye Closed SVG
                      
                    )}
                  </span>
            </div>
            {errors.passwordError && <p className="text-red-500 text-sm mt-1">{errors.passwordError}</p>}

            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

            {/* <div className="text-right">
              <button onClick={handleForgotPassword} className="text-green-700 text-xs p-3">Forgot password?</button>
            </div> */}

            <button type="submit" className="w-full block text-center bg-[#299F1F] text-white py-2 px-6 rounded-md hover:bg-green-700 transition mt-4">
              Sign In
            </button>
          </form>

          <p className="text-sm text-gray-600 mt-4 text-center">
            Don't have an account? 
            <button onClick={handleSignUpClick} className="text-green-700 hover:underline ml-1">
              Sign Up
            </button>
          </p>
        </div>
      </div>

      {/* Right Side - Banner */}
      <div className="hidden md:flex w-1/2 bg-[#299F1F] justify-center items-center text-white relative px-6 text-center">
        <div>
          <div className="flex items-center gap-2 justify-center">
            <h1 className="text-3xl font-bold">Janta Pay</h1>
          </div>
          <p className="mt-4 text-gray-300">Secure and seamless payment management</p>
        </div>
      </div>
      <div>
      {/* <button onClick={notify}>Show Toast</button> */}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
    </div>
  );
};

export default Login;